import React, { useEffect } from 'react';
import { Shield, Info, Home, Scale, AlertTriangle, FileCheck } from 'lucide-react';
import Footer from '../v1/footer.jsx';
import '../v1/estiloAcuicultura.css';

const TerminosUsoAcuiculturaPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const publicUrl = process.env.PUBLIC_URL;

    return (
        <div id="acuicultura-v1-root" className="min-vh-100 d-flex flex-column">
            <div className="container-fluid p-0 flex-grow-1 fondo-gris">
                {/* Hero Section Simplificado */}
                <header className="bg-marine-900 py-5 text-white position-relative overflow-hidden" style={{ height: '320px' }}>
                    <img className="video-background" src="https://www.ifop.cl/wp-content/uploads/2020/07/Habitat-emergente-bajo-cultivo-de-bivalvos.jpg" alt="Fondo Acuicultura" />
                    <div className="video-overlay"></div>
                    <div className="position-absolute top-0 start-0 w-100 h-100 opacity-10">
                        <div className="bg-gradiente-marine w-100 h-100"></div>
                    </div>
                    <div className="container px-4 position-relative z-2">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-4 pt-4">
                            <div className="d-flex align-items-center gap-4">
                                <a className="align-self-start" href={`${publicUrl}/acuicultura`}>
                                    <img src={`${publicUrl}/blanco.png`} alt="Logo IFOP" style={{ width: '100px' }} />
                                </a>
                                <div>
                                    <h1 className="display-6 fw-bold text-white mb-2 tracking-tight">
                                        TÉRMINOS DE <span className="text-marine-300">USO</span>
                                    </h1>
                                    <nav aria-label="breadcrumb">
                                    </nav>
                                </div>
                            </div>
                            <a href={`${publicUrl}/acuicultura`} className="btn d-flex align-items-center gap-2 px-4 py-2 text-white rounded-3 border border-white border-opacity-10 shadow-sm" style={{ backgroundColor: 'rgba(255,255,255,0.05)', backdropFilter: 'blur(10px)' }}>
                                <Home size={16} />
                                <span className="small fw-semibold">Volver al Buscador</span>
                            </a>
                        </div>
                    </div>
                </header>

                <main className="container-xl_ px-0 py-1" style={{ position: 'relative', zIndex: '10', marginTop: '-64px' }}>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-9">
                            <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
                                <div className="card-body p-4 p-md-5 bg-white">

                                    <section className="mb-5">
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-marine-100 p-3 rounded-4 text-marine-600">
                                                <Scale size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Aceptación de las Condiciones</h2>
                                        </div>
                                        <p className="text-secondary leading-relaxed">
                                            Al acceder y utilizar el Buscador de Datos Pesqueros del Instituto de Fomento Pesquero (IFOP), usted acepta estar sujeto a estos Términos de Uso. Esta plataforma ha sido diseñada para facilitar el acceso a información y datos pesqueros con fines de investigación, análisis y conocimiento público.
                                        </p>
                                    </section>

                                    <hr className="my-2 border-light" />

                                    <div className="row g-5">
                                        <div className="col-md-6">
                                            <section className="h-100">
                                                <div className="d-flex align-items-center gap-3 mb-4">
                                                    <div className="bg-primary-subtle p-2 rounded-3 text-primary">
                                                        <FileCheck size={20} />
                                                    </div>
                                                    <h3 className="h5 fw-bold text-marine-800 mb-0">Uso Correcto de los Datos</h3>
                                                </div>
                                                <p className="small text-secondary">
                                                    Los usuarios se comprometen a hacer un uso adecuado de los datos proporcionados:
                                                </p>
                                                <ul className="small text-secondary ps-3">
                                                    <li className="mb-2">Citar apropiadamente al IFOP como fuente de la información.</li>
                                                    <li className="mb-2">No utilizar los datos para fines ilícitos o engañosos.</li>
                                                    <li className="mb-2">No comercializar ni vender la información extraída de la plataforma.</li>
                                                    <li className="mb-2">Respetar la integridad de los datos sin alterarlos ni falsificarlos.</li>
                                                </ul>
                                            </section>
                                        </div>

                                        <div className="col-md-6">
                                            <section className="h-100">
                                                <div className="d-flex align-items-center gap-3 mb-4">
                                                    <div className="bg-danger-subtle p-2 rounded-3 text-danger">
                                                        <AlertTriangle size={20} />
                                                    </div>
                                                    <h3 className="h5 fw-bold text-marine-800 mb-0">Limitación de Responsabilidad</h3>
                                                </div>
                                                <p className="small text-secondary">
                                                    Es importante tener en cuenta las siguientes limitaciones:
                                                </p>
                                                <ul className="small text-secondary ps-3">
                                                    <li className="mb-2">La información se proporciona "tal cual", sin garantías de ningún tipo.</li>
                                                    <li className="mb-2">El IFOP no se hace responsable por las interpretaciones o decisiones tomadas basadas en los datos publicados.</li>
                                                    <li className="mb-2">La disponibilidad del sistema puede verse interrumpida por mantenimiento o razones técnicas.</li>
                                                </ul>
                                            </section>
                                        </div>
                                    </div>

                                    <hr className="my-2 border-light" />

                                    <section className="mb-5">
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-info-subtle p-3 rounded-4 text-info-emphasis">
                                                <Shield size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Propiedad Intelectual</h2>
                                        </div>
                                        <div className="p-4 bg-light rounded-4 border-start border-marine-500 border-4">
                                            <p className="text-secondary mb-0">
                                                Todo el contenido de esta plataforma, incluyendo diseños, textos, gráficos y las bases de datos subyacentes, son propiedad intelectual del Instituto de Fomento Pesquero (IFOP). El acceso a la plataforma no transfiere ningún derecho de propiedad sobre estos elementos.
                                            </p>
                                        </div>
                                    </section>

                                    <section>
                                        <div className="d-flex align-items-center gap-3 mb-4">
                                            <div className="bg-warning-subtle p-3 rounded-4 text-warning-emphasis">
                                                <Info size={32} strokeWidth={1.5} />
                                            </div>
                                            <h2 className="h4 fw-bold text-marine-900 mb-0">Modificaciones a los Términos</h2>
                                        </div>
                                        <p className="text-secondary">
                                            El IFOP se reserva el derecho de modificar estos términos en cualquier momento. El uso continuado de la plataforma después de la publicación de los cambios constituye la aceptación de los mismos.
                                        </p>
                                        <div className="alert alert-marine-light rounded-4 d-flex align-items-center gap-3 p-4">
                                            <div>
                                                <h4 className="h6 fw-bold mb-1">¿Consultas adicionales?</h4>
                                                <p className="small mb-0 opacity-75">Si tiene alguna pregunta sobre las condiciones de uso, por favor contacte a los administradores del sistema.</p>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default TerminosUsoAcuiculturaPage;
